import { createActionGroup, props } from '@ngrx/store';
import { Group, GroupMember, User } from '@era/security-sdk';
import { ErrorModel } from '@era/app';
import { UserApiActions } from '../../stores/user/user.actions';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MemberUserResolverActions = createActionGroup({
  source: 'Member User Resolver',
  events: {
    'Member users requested': props<{ group: Group }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const GroupApiActions = createActionGroup({
  source: 'Group API',
  events: {
    'Member users loaded': props<{ memberUsers: GroupMember[] }>(),
    'Member users loaded error': props<{ error: ErrorModel }>(),
    'Member users group deleted': props<{ memberUser: GroupMember }>(),
    'Member users delete error': props<{ error: ErrorModel }>(),
    'Member users added': props<{ group: Group; userToAdd: User }>(),
    'Member users added error': props<{ error: ErrorModel }>(),
  },
});

// Re-export UserApiActions.userDeleted for cross-store reference
export { UserApiActions };

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const MemberUserListActions = createActionGroup({
  source: 'Member User List',
  events: {
    'Member users deleted': props<{ memberUser: GroupMember }>(),
    'Member users added': props<{ group: Group; userToAdd: User }>(),
  },
});
